var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 58,
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 58,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6905 42.0159H34.6992V15.2427H49.6905V42.0159Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.66 28.6271C35.66 23.1961 38.2189 18.3582 42.2037 15.2405C39.2897 12.9607 35.612 11.6 31.6152 11.6C22.1531 11.6 14.4829 19.2232 14.4829 28.6271C14.4829 38.0311 22.1531 45.6543 31.6152 45.6543C35.612 45.6543 39.2897 44.2936 42.2037 42.0137C38.2189 38.896 35.66 34.0582 35.66 28.6271Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9094 28.6271C69.9094 38.0311 62.2393 45.6543 52.7771 45.6543C48.7803 45.6543 45.1026 44.2936 42.1875 42.0137C46.1734 38.896 48.7323 34.0582 48.7323 28.6271C48.7323 23.1961 46.1734 18.3582 42.1875 15.2405C45.1026 12.9607 48.7803 11.6 52.7771 11.6C62.2393 11.6 69.9094 19.2232 69.9094 28.6271Z",
    fill: "#F79E1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.99dcd1aa13253c3763af33b88300d6b0.svg";
export { ForwardRef as ReactComponent };